<template>
  <div>
    <company-form-modal></company-form-modal>

    <page-heading title="Companies" :loading="fetching">
      <template slot="buttons">
        <el-button @click="handleOpenCompanyModal" type="info">Add New Company</el-button>
      </template>
    </page-heading>

    <content-placeholder v-if="fetching">
      <el-card>
        <p class="text text-75"></p>
        <p class="text text-full"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
        <p class="text text-50"></p>
      </el-card>
    </content-placeholder>

    <div v-else>
      <el-card>
        <div slot="footer">
          Total: {{all.length}}
        </div>
        <el-table
          :data="all"
          stripe
          :default-sort = "{prop: 'name', order: 'ascending'}"
          style="width: 100%"
          :border="true"
          class="depth">

          <el-table-column type="expand">
            <template slot-scope="props">
              <el-row :gutter="20">
                <el-col :span="12">
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column label="Name" sortable prop="name"></el-table-column>
          <el-table-column label="Created" sortable prop="created_at"></el-table-column>
          <el-table-column label="updated_at" prop="updated_at" sortable></el-table-column>
          <el-table-column label="Status" sortable prop="status" align="center"></el-table-column>
          <el-table-column label="" width="160">
            <template slot-scope="scope">
              <router-link :to="{ name: 'companies', params: { id: scope.row.id } }">
                <el-tooltip effect="dark" content="Go to company's page" placement="bottom">
                  <el-button size="mini" type="primary"><i class="fas fa-search"></i></el-button>
                </el-tooltip>
              </router-link>
              <el-tooltip effect="dark" content="Edit account details" placement="bottom">
                <el-button size="mini" plain @click="updateCompany(scope.row.id)"><i class="fas fa-pen"></i></el-button>
              </el-tooltip>
              <el-tooltip effect="dark" content="Disable user" placement="bottom">
                <el-button size="mini" plain @click="deactivateCompany(scope.row.id)" v-if="!scope.row.master"><i class="fas fa-times"></i></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

      </el-card>
    </div>
  </div>
</template>

<script>
  import CompanyFormModal from '@/components/company/CompanyFormModal';

  import { mapActions, mapGetters } from 'vuex';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'CompaniesPage',
    components: {
      companyFormModal: CompanyFormModal,
    },
    created() {
      this.fetchCompanies();
    },
    data() {
      return {
        translationPrefix: 'pages.companies',
      };
    },
    computed: {
      ...mapGetters('entities/companies', ['fetching']),

      all() {
        return this.$store.getters['entities/companies/query']()
          .get();
      },

    },
    methods: {
      ...mapActions('entities/companies', ['fetchCompanies', 'openFormModal', 'deleteCompany']),

      handleOpenCompanyModal() {
        this.openFormModal();
      },

      updateCompany(id) {
        return id;
      },

      deactivateCompany(id) {
        const self = this;
        this.$confirm('Are you sure you want to delete this company?', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          title: 'Confirm',
        }).then(() => {
          self.deleteCompany(id)
            .then((response) => {
              if (response.status) {
                showSuccessMessage('Company deleted successfully');
              } else {
                showErrorMessage(response.error);
              }
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
.el-button{
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Companies.vue